<template>
  <span
    :class="[
      'inline-flex h-6 shrink-0 items-center whitespace-nowrap rounded-full px-3 text-xs font-medium',
      pill.class
    ]"
  >
    {{ pill.label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { type RowState, STATE_PILLS } from "./mapColumns";

const props = defineProps<{ state: RowState }>();

const pill = computed(() => STATE_PILLS[props.state]);
</script>
